export default defineNuxtRouteMiddleware(async () => {
    await useStoreApp().initApp();
});
